import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce9f50c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-28 rounded-lg h-28 flex items-center justify-center" }

import { IonCard, IonIcon } from "@ionic/vue";
import { addOutline } from "ionicons/icons";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateHzbaCard',
  props: {
  useMinHeight: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), {
    class: _normalizeClass(["m-0 rounded-sm bg-white acon-card-shadow flex items-center justify-center cursor-pointer hover:shadow-xl", { 'min-height': __props.useMinHeight }])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(IonIcon), { icon: _unref(addOutline) }, null, 8, ["icon"])
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})